export class NumberUtils {
  static maxWidthHeightImage : number = 1024;
  static maxSizeImage: number = 900000;
  static numPad = 6;
  static waitTimer = 2500;
  static page: number = 1;
  static perPage: number = 12;
  static currentTotalInternalUser = undefined;
  static countDownNumber: number = 3;
}
